import { Box, Button, ButtonExtendedProps, Text } from 'grommet';

export type MessageButtonProps = Omit<ButtonExtendedProps, 'label'> & {
  label: string;
  /** Unread messages in the conversation it opens */
  unread?: number;
};

/** A button that opens a conversation, with a count of its unread messages */
export const MessageButton = ({ label, unread = 0, primary, ...props }: MessageButtonProps) => (
  <Button
    size="small"
    primary={primary}
    a11yTitle={unread ? `${label}, ${unread} unread` : undefined}
    label={
      <Box direction="row" align="center" gap="6px">
        <Text size="14px" weight={600}>
          {label}
        </Text>
        {unread > 0 && (
          <Box background={primary ? 'white' : 'brand'} round="999px" pad={{ horizontal: '6px' }}>
            <Text size="12px" weight={600} color={primary ? 'brand' : 'white'}>
              {unread}
            </Text>
          </Box>
        )}
      </Box>
    }
    {...props}
  />
);
